import * as types from '../constants';
import api from '../api';
import localStorage from 'store';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _map from 'lodash/map';
import hydrateVErrors from '../utils/vErrors';
import hydrateVMessages from '../utils/vMessages';

const setForgotData = obj => dispatch =>
  dispatch({
    type: types.SET_FORGOT_DATA,
    payload: obj,
  });

const setUser = payload => dispatch => {
  let { user } = payload;
  let insurances = _map(user.insurances, insurance => ({
    type: insurance.type,
    title: insurance.name,
    value: insurance.code,
    id: insurance.name,
  }));

  if (user.is_call_center_operator) {
    insurances = [
      {
        id: '',
        title: 'Без СК',
        type: '',
        value: '',
      },
      ...insurances,
    ];
  }

  let selectedInsurance = localStorage.get('insurance_item');

  if (selectedInsurance) {
    if (!_find(insurances, i => i.value === selectedInsurance.value)) {
      selectedInsurance = null;
    }
  }

  if (insurances.length && selectedInsurance === null) {
    let first = _get(insurances, '0');

    selectedInsurance = {
      value: first.value,
      id: first.id,
      title: first.title,
      type: first.type,
    };
  }

  if (!selectedInsurance) {
    localStorage.remove('insurance_item');
  }

  const userPayload = {
    ...payload.user,
    insurances,
  };
  localStorage.set('user', userPayload);
  localStorage.set('insurance_item', selectedInsurance);

  dispatch({
    type: types.SET_USER,
    payload: userPayload,
  });
};

const check = () => async dispatch => {
  try {
    dispatch(setLoader(true));
    let { data, status } = await api.post('/auth/check');
    if (status === 200) {
      dispatch(setUser(data));
    }
    dispatch(setLoader(false));
  } catch (e) {
    console.error(e);
    dispatch(setLoader(false));
  }
};

const loginStart = () => ({
  type: types.LOGIN_START,
});

const loginSuccess = payload => {
  if (payload) {
    const { token, user } = payload;

    let insurances = _map(user.insurances, insurance => {
      return {
        type: insurance.type,
        title: insurance.name,
        value: insurance.code,
        id: insurance.name,
      };
    });

    if (user.is_call_center_operator) {
      insurances = [
        {
          id: '',
          title: 'Без СК',
          type: '',
          value: '',
        },
        ...insurances,
      ];
    }

    const userPayload = {
      user: {
        ...user,
        insurances,
      },
      token,
    };
    localStorage.set('token', token);
    localStorage.set('user', userPayload.user);

    return {
      type: types.LOGIN_SUCCESS,
      payload: userPayload,
    };
  }
};

const loginFailure = payload => ({
  type: types.LOGIN_FAILURE,
  payload,
});

const setVErrors = payload => ({
  type: types.SET_V_ERRORS,
  payload,
});

const setVMessages = payload => ({
  type: types.SET_V_MESSAGES,
  payload,
});

const setLoader = payload => ({
  type: types.SET_LOADER,
  payload,
});

const login = payload => async dispatch => {
  try {
    dispatch(setLoader(true));
    dispatch(loginStart());
    let { data } = await api.post('/auth/login', { ...payload });
    dispatch(loginSuccess(data));
    dispatch(setLoader(false));
    return true;
  } catch (e) {
    dispatch(loginFailure());
    dispatch(setVErrors(hydrateVErrors(e)));
    dispatch(setVMessages(hydrateVMessages(e)));
    dispatch(setLoader(false));
  }
};

const forgotPassword = form => async dispatch => {
  try {
    dispatch({ type: types.FORGOT_PASSWORD_START });
    const { data } = await api.post('/auth/forgot-password', form);
    const payload = {
      ...data,
      sms: true,
    };
    dispatch({ type: types.FORGOT_PASSWORD_SUCCESS, payload: payload });
    return payload;
  } catch (ex) {
    dispatch({ type: types.FORGOT_PASSWORD_FAILURE, payload: ex });
    return true;
  }
};

const resetPassword = form => async dispatch => {
  try {
    dispatch({ type: types.RESET_PASSWORD_START });
    const { data } = await api.post('/auth/reset-password', form);
    dispatch({ type: types.RESET_PASSWORD_SUCCESS, payload: data });
    return data;
  } catch (ex) {
    dispatch({ type: types.RESET_PASSWORD_FAILURE, payload: ex });
    return true;
  }
};

const setMessage = payload => dispatch =>
  dispatch({ type: types.SET_MESSAGE, payload });

const logout = () => dispatch => {
  localStorage.remove('token');
  localStorage.remove('user');
  localStorage.remove('insurance_item');
  dispatch({
    type: types.LOGOUT,
  });
};

export {
  check,
  setForgotData,
  login,
  setMessage,
  resetPassword,
  forgotPassword,
  setVErrors,
  setVMessages,
  loginFailure,
  logout,
};
